import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Card from '../components/Card';
import { findDoc } from '../docs';
import { DOC_MAX_WIDTH } from '../docs/docBits';

// One documentation page (doc-277). The :slug is looked up in the registry; an
// unknown slug renders an empty state with a way back, NOT a redirect — a
// silent bounce to /docs makes a bad bookmark look like the doc was deleted.

export default function DocPage() {
  const { slug } = useParams();
  const doc = findDoc(slug);

  return (
    <div className="canvas-inner animate-fade-in">
      <div style={{ maxWidth: DOC_MAX_WIDTH }}>
        <Link
          to="/docs"
          className="row"
          style={{
            gap: 4,
            marginBottom: 16,
            fontSize: 'var(--font-size-sm)',
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            width: 'fit-content',
          }}
        >
          <ChevronLeft className="w-3.5 h-3.5" />
          Documentation
        </Link>

        {!doc ? (
          <Card title="Doc not found">
            <div
              style={{
                fontSize: 'var(--font-size-base)',
                lineHeight: 1.65,
                color: 'var(--text-secondary)',
              }}
            >
              There is no document at this address. It may have been renamed.
            </div>
            <div style={{ marginTop: 14 }}>
              <Link className="btn outline sm" to="/docs">
                Back to Documentation
              </Link>
            </div>
          </Card>
        ) : (
          <>
            <div className="page-header">
              <div>
                <div className="page-eyebrow">Documentation</div>
                <h1 className="page-title">{doc.title}</h1>
                {doc.summary && <div className="page-subtitle">{doc.summary}</div>}
              </div>
            </div>
            <doc.Component />
          </>
        )}
      </div>
    </div>
  );
}
